import React, { useRef } from 'react';
import { isAutoFontSize, getManualFontSizeStyle } from '../utils/scheduleFontSize';
import { useFitEmFontSize } from '../hooks/useFitEmFontSize';

/**
 * Renders a schedule row value with optional manual or auto-sized font.
 */
export default function ScheduleValue({
  value,
  className,
  style,
  fontSize,
  isCurrent = false,
  children,
  suppressHydrationWarning,
  ...rest
}) {
  const ref = useRef(null);
  const autoSize = isAutoFontSize(fontSize);

  useFitEmFontSize(ref, {
    enabled: autoSize,
    text: value,
    isCurrent,
  });

  const classNames = autoSize
    ? [className, 'schedule-value-autosize'].filter(Boolean).join(' ')
    : className;

  return (
    <span
      ref={ref}
      className={classNames}
      style={{
        ...style,
        ...getManualFontSizeStyle(fontSize),
      }}
      suppressHydrationWarning={suppressHydrationWarning}
      {...rest}
    >
      {children ?? value}
    </span>
  );
}
